export enum EnumDiscipline {
  AACS = 1,
  CPMS = 2,
  CCTV = 3,
  ELEC = 4,
  HVMS = 6,
  IHAS = 7,
  SAFE = 8,
  SART = 9,
  VCOM = 10,
  ICTS = 11,
  CSEC = 12,
  CAD = 13,
  HOTL = 14,
  PHYS = 15,
  FIRE = 16,
  PMRS = 17,
  None = 0,
  All = 100,
}
